<script setup>
import PlaneEditor from "@/components/common/PlaneEditor.vue";
import Comment from "@/components/common/Comment.vue";
import Alert from "@/components/common/Alert.vue";
</script>
<template>
<v-dialog
    v-model="blockedit"
    fullscreen
    transition="dialog-bottom-transition"
>
<v-card>
        <v-toolbar
            flat
            dark
            color="#E13532"
        >
            <v-spacer />
            <v-btn
                icon
                @click="close"
            >
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-toolbar>
    <v-card-text class="pb-2">
        <p>コメントをチェックしながら段落の内容を編集できます。段落内で改行したい場合はShift+改行を押してください。そのまま改行すると段落を分割します。</p>
    </v-card-text>
    <v-card-text class="pb-2">
    <div class="blockarea">
        <div class="blockeditor">
            <v-card width="100%" max-height="69vh" min-height="69vh" class="overflow-y-auto" outlined flat>
                <v-card-text class="py-0 px-0">
                    <PlaneEditor v-on:editobj="editordata($event)" :dataobj="selected_data" />
                </v-card-text>
            </v-card>
        </div>
        <div class="blockmessage" id="blockmess">
            <v-card width="100%" max-height="70vh" min-height="70vh" outlined flat>
                <v-card-text class="py-3" v-if="dspcomment.length>0">
                    <v-list style="max-height:65vh" class="overflow-y-auto" id="blockmess_comment">
                        <v-list-item v-for="comment,index in dspcomment" :key="index" class="mb-2 px-1">
                            <Comment :sendcomment="comment" />
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <Alert messagetitle="コメントはありません" message="下記のフォームで先方とメッセージを交換できます" messagetype="0" blockheight="65vh" v-else />
            </v-card>
        </div>
    </div>
</v-card-text>
<v-card-actions>
    <v-spacer />
    <v-btn
        @click="reflect"
        :disabled = "disabled"
        color="#E13532"
        :dark="!disabled"
    >
        保存して反映
    </v-btn>
    <v-spacer />
</v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
export default {
    props : ["blockcomment",],
    computed : {
        editdata : function(){
            return this.$store.getters['doc_info/get_editdata'];
        },
        selected_data : function(){
            let ret = null;
			if(this.editdata.blocks == undefined)
				return;
            for(let cnt = 0 ;this.editdata.blocks.length > cnt ; cnt++)
            {
                if(this.editdata.blocks[cnt].id==this.blockid)
                {
                    ret = this.editdata.blocks[cnt];
                    break;
                }
            }
            return ret;
        },
    },
    watch : {
        blockedit : function(){
            if(this.blockedit == true)
            {
                if(this.mo == null)
                {
                    this.$nextTick(()=>{
                        //this.scrollcontrol();
                        this.servdom();
                    });
                }
            }
            else
            {
                /*
                if(this.mo != null)
                {
                    this.mo.disconnect();
                }
                */
            }
        },
        updateblock : function(){
            this.disabled = false;
        },
    },
    data : function(){
        return {
            blockedit : false,
            blockid   : "",
            mo        : null,
            updateblock : null,
            disabled   : true,
			dspcomment  : [],
        };
    },
    methods : {
        reflect : function(){
            this.$store.commit("update_block/set_update",{data:this.updateblock,id:this.blockid});
            this.blockedit = false;
        },
        editordata : function(data){
            this.updateblock = data;
        },
        open : function(block_id){
            this.blockedit = true;
            this.blockid=block_id;
			if(this.blockcomment != undefined)
			{
				this.dspcomment = this.blockcomment;
			}
        },
        close : function(){
            this.blockedit = false;
        },
        servdom : function(){
            this.$nextTick(function(){
                let elem = document.getElementById('blockmess_comment');
                if(elem != null)
                {
                    if(elem.scrollHeight != 0)
                        elem.scrollTop=elem.scrollHeight;
                }
            });
        },
        scrollcontrol : function(){
            var element = document.getElementById('blockmess');
            let thisobj = this;
            this.mo = new MutationObserver(function() {
                thisobj.servdom();
            });
            var config = {
              childList: true,
              attributes: true,
              characterData: true,
              subtree: true,
            };

            //監視の開始
            this.mo.observe(element, config);
        },
    },
}
</script>
<style>
.blockarea{
    display : flex;
    padding : 10px;
}
.blockeditor{
    width : 800px;
    height: 70vh;
}
.blockmessage{
    padding : 0 10px;
    width : calc(100% - 800px);
    height: 70vh;
}
</style>
